import React from "react";
import styled from "styled-components";
import { colors2 } from "oolib";
import { UI_CAPTION_SEMIBOLD_DF } from "oolib/dist/v2/components/Typo2";
import LexicalTextEditor from "@/components/inputs/TextEditor/LexicalTextEditor";

const TONE_GLOW = {
  positive: "#57BE454D",
  negative: "#FF6A6A4D",
  neutral:  "#03143033",
};

const Card = styled.div`
  position: relative;
  padding: 1.2rem 1.3rem;
  border-radius: 0.6rem;
  background: #0013320D;
  margin-bottom: 0.6rem;
  overflow: hidden;

  &:last-child {
    margin-bottom: 0;
  }
`;

const Glow = styled.span`
  position: absolute;
  top: 50%;
  left: -90px;
  transform: translateY(-50%);
  width: 110px;
  height: 110px;
  border-radius: 50%;
  background: ${(p) => p.$color};
  filter: blur(45px);
  pointer-events: none;
  z-index: 0;
`;

const Content = styled.span`
  position: relative;
  z-index: 1;
  display: block;
`;

export function MentionCard({ tone = "neutral", fragment, children }) {
  const hasLexical = fragment?.isLexical && fragment?.editorState;
  const fallbackText = children || fragment?.allText || "";

  return (
    <Card>
      <Glow $color={TONE_GLOW[tone] || TONE_GLOW.neutral} />
      <Content>
        {hasLexical ? (
          <LexicalTextEditor
            variant="rich"
            readOnly
            v2
            disableViewHighlights
            disableCreateHighlights
            value={{ isLexical: true, editorState: fragment.editorState }}
          />
        ) : (
          <UI_CAPTION_SEMIBOLD_DF style={{ color: colors2.grey80, lineHeight: 1.55 }}>{fallbackText}</UI_CAPTION_SEMIBOLD_DF>
        )}
      </Content>
    </Card>
  );
}
